import React from "react";

import "./styles.scss"
import SourceListMain from "../../esg-chat/source-list";

const InvestorSourceList = () => {
    return (
        <SourceListMain model="Investor" />
    )
}

export default InvestorSourceList